import React from 'react'


export default function ReactNative() {
  return (
    <div className='bg-white'>

        <p>
            this is react native card 
            
        </p>
      
    </div>
  )
}
